import React from 'react';
import Style from 'styles/components/comachi_term_of_use.module.scss';

const ComachiTermOfUse = () => {
  return (
    <div className={Style.termsOfUse}>
      <h3 className={Style.termsOfUse__h3}>comachicartサービス利用規約</h3>
      <br />
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第1条 当社及び利用規約の役割</h4>
        <p className={Style.termsOfUse__sentence}>
          1.株式会社イーゼ（第2条「定義」第1項にて「当社」と定義します）は、店舗運営者がインターネット上で商品の販売を行うことができるプラットフォーム提供サービス（第2条「定義」第2項にて「本サービス」と定義します）を提供するプラットフォーマーです。本サービスは、店舗運営者とユーザー、顧客間の売買契約の締結、出品や購入等についての保証、両者間で発生した紛議等に関しては、当社は一切関与せず、全て当事者である店舗運営者の自己責任とします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.本規約は、当社と店舗運営者の両者が本サービスで守るべき義務と、本サービスで得られる権利が記載されています。本サービスをご利用になる方は、本サービスの利用を申し込む前に、必ず全文をお読み下さいますようお願い致します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.本規約外で当社が提供する本サービスの説明・管理画面上の説明・ガイドライン（以下「個別規定」といいます）は、本規約に含まれます。個別規定の内容が本規約と異なる場合は、個別規定が優先して適用されるものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第2条 定義</h4>
        <p className={Style.termsOfUse__sentence}>
          本規約で使用されている用語の定義は、例外的に本規約の他で定義されている場合を除き、以下のとおりとします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)「当社」とは、株式会社イーゼのことをいいます。なお、社名が変更された場合は、その社名変更後の会社のことをいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)「本サービス」とは、店舗運営者がインターネット上で商品（サービスの提供を含みます。以下同じ）の販売を行うことができるプラットフォーム提供サービス「comachicart」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）のことをいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)「店舗運営者」とは、本サービスを通じてユーザーに対して商品を提供する者で、第3条（店舗運営者登録）に従って店舗運営者としての登録を行った者をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (4)「店舗登録申込者」とは、本サービスに店舗運営者として利用申込みをする者をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)「ユーザー」とは、本サービスを通じて店舗運営者から商品の提供を受けることを目的として、当社及び店舗登録申込者の指定する方法でユーザーとしての会員登録を行った個人又は法人をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (6)「顧客」とは、本サービスを通じて店舗運営者から商品の注文をすることにより、店舗運営者との間で売買契約を成立させた者をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (7)「店舗運営者発信情報」とは、店舗運営者が本サービス上で発信する情報（入力された値、文章、画像、動画その他のデータを含みますがこれらに限りません。）をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (8)「ユーザーデータ」とは、ユーザーが当社ウェブサイトを利用して投稿その他送信するコンテンツ（レビュー、入力された値、文章、画像、動画その他のデータを含みますがこれらに限りません。）を意味します。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (9)「ID」とは、店舗運営者とその他の者を識別するために用いられるメールアドレス及びユーザー名をいいます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (10)「パスワード」とは、IDと組み合わせて、店舗運営者とその他の者を識別するために用いられる符号をいいます。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第3条 店舗運営者登録</h4>
        <p className={Style.termsOfUse__sentence}>
          1.本サービスで店舗運営者として商品を出品することを希望する店舗登録申請者は、本規約に書いてある内容の全てに同意して、当社が決めた登録方法に従って本サービスへの登録申請を行う必要があります。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、当社の基準に従って、店舗登録申請者に対して審査を行い、当社が登録を認める場合には、その旨を登録申請者に通知します。店舗登録申請者の店舗運営者としての登録は、当社が本項の通知を行ったことをもって完了したものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.前項に定める登録の完了時に、サービス利用契約（以下「利用契約」といいいます）が店舗運営者と当社の間に成立し、店舗運営者は本サービスを本規約に従い利用することができるようになります。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.当社は、以下の場合に店舗運営者としての登録を承諾しないことがあります。
        </p>
        <p className={Style.termsOfUse__indentSentence}>(1)店舗登録申込者が実在しない場合</p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)個人かつ未成年である店舗登録申込者が、本サービスを利用することについて親権者の同意を得ていない場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)店舗登録申込者が届け出ている電子メールの連絡先に連絡がとれない場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>(4)店舗登録申込者について、本規約に違反することがあった場合</p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)店舗登録申込者が届け出ている情報に嘘の内容があるか、又はこれに類する不正確な内容の記載が含まれている場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (6)店舗登録申込者が以前に本サービスの利用継続を断られたことがある場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (7)店舗登録申込者が法令に違反する行為若しくは公序良俗に反する行為をした場合又はそれらの行為につながるおそれがある場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>(8)その他当社が不適当と認めた場合</p>
        <p className={Style.termsOfUse__sentence}>
          5.第4項において、当社が店舗登録申込者による店舗運営者の登録を承諾しないと判断した場合について、当社はその不承諾の理由を公表いたしません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          6.店舗登録申込者が未成年者である場合には、登録申請及び本サービスの利用について親権者の同意を得ていることを条件とします。未成年者が、親権者から本サービスの利用について同意を得ていない場合又は自己の年齢について成年であると嘘をついて本サービスを利用した場合、本サービスにおける一切の法律行為を取消すことはできません。なお、本規約を合意した時に未成年であった店舗運営者が、成年に達した後に本サービスを利用した場合、その店舗運営者は、本サービスで過去に行った一切の法律行為について、追認したものとみなされます。
        </p>
      </div>{' '}
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第4条 有効期間</h4>
        <p className={Style.termsOfUse__sentence}>
          利用契約は、店舗運営者について第3条（店舗運営者登録）に基づく店舗運営者の登録が完了した日に効力を生じ、当該店舗運営者の登録が解約もしくは取消された日又は本サービスの提供が終了した日のいずれか早い日まで、当社と店舗運営者との間で有効に存続するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第5条 店舗運営者情報等の取扱い</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、本サービスにおいて、店舗運営者情報、商品情報、FAQ、お知らせその他の店舗に関する情報（以下「店舗運営者情報等」といいます）を掲載することができます。これらはユーザーが店舗を利用し、あるいは商品を検索するときの貴重な情報源となります。そのため、店舗運営者情報等は、実際とはかけ離れた内容や、ユーザーを混乱させるような掲載内容にしてはいけません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、当社のプライバシーポリシーに従い、店舗運営者の情報を管理します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者が個人である場合、ユーザーに対して本サービスを提供するために必要な範囲で店舗運営者の個人情報が提供されることに予め承諾するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.店舗運営者は、本条に定めるとおりに当社が店舗運営者情報等を扱い、保有することに同意することとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.店舗運営者は、店舗運営者情報等については正しい情報を登録するものとし、その内容に変更が生じた場合には当社の定める方法により速やかに変更登録を行い、いつも正しい状態になるよう維持しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          6.店舗運営者は、本サービス上においてプライバシーポリシーを定め、掲載しなければなりません。また、本サービスで取得したユーザー等の個人情報について、本サービスのためだけに使用するものとし、当該個人情報を本サービス外で利用をする場合は、必ずユーザーから個別に許可を得るものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          7.店舗運営者が、前5項又は前6項又に記載した義務を怠ったことにより、店舗運営者や第三者に生じた損害について、当社は一切責任を負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          8.店舗運営者は自己の個人情報が本サービスを通じて漏洩しないように、自己の責任において管理を行うものとします。店舗運営者の操作ミス等により店舗運営者の個人情報が第三者に渡った場合において、当社はその責任の一切を負いません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          9.第23条（本サービスの停止、変更、終了）に定める場合に該当する場合、当社は店舗運営者へ通知をすることなく、店舗運営者に対する本サービス上の権限の停止及び店舗運営者登録内容の削除を行うことができます。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第6条 店舗運営者の責任</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、自己の責任において、本サービスで使用するID、メールアドレス及びパスワードを適切に管理及び保管するものとし、これを第三者に利用させたりしてはならないものとし、他にも第三者に対し貸与、譲渡、名義変更及び売買等をしてはならないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.
          ID、メールアドレス及びパスワードの管理不十分、使用方法を間違えること、第三者が使用した等によって生じた損害に関する責任は店舗運営者が負わなければならないものとし、当社は一切の責任を負いません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第7条 店舗運営者への通知</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社から店舗運営者への通知は、本サービス上での掲示又は電子メールなど、当社が適当と判断した方法により行います。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.前項の規定に基づき、当社から店舗運営者への通知を本サービス上での掲示又は電子メールで行う場合には、本サービス上での掲載又は電子メールの送信が行われた時点で通知の効力を生じるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者は、当社から店舗運営者への通知を随時確認する義務を負うものとします。店舗運営者がその確認を怠ったことにより発生した店舗運営者の損害に関して、当社は一切責任を負いません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第8条 店舗運営者の禁止事項</h4>
        <p className={Style.termsOfUse__sentence}>
          店舗運営者は、本サービスの利用に関して、以下の行為を行わないものとします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>(1)本サービスの運営を妨害する行為</p>
        <p className={Style.termsOfUse__indentSentence}>(2)第三者に本サービスを利用させる行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)本サービスにおける店舗運営者の資格を停止ないし無効にされた店舗運営者に代わって会員登録をする行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(4)当社又は他者になりすます行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)本人の同意を得ることなく、第三者の会員登録情報を取得する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (6)第三者を差別もしくは誹謗中傷し、又は他者の名誉若しくは信用を毀損する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (7)倫理的に問題がある低俗、有害、下品な行為、他人に嫌悪感を与える内容の情報を開示する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (8)ポルノ、売春、風俗営業、これらに関連する内容の情報を開示する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(9) 詐欺等の犯罪に結びつく又は結びつくおそれがある行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (10)当社若しくは第三者に不利益を与える行為(11)当社若しくは第三者の知的財産権を侵害する行為、又は侵害するおそれのある行為（このような侵害を直接または間接的に引き起こすことにつながる行為を含みます）
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (12)当社若しくは第三者の財産、プライバシー若しくは肖像権を侵害する行為、又は侵害するおそれのある行為（このような侵害を直接または間接的に引き起こすことにつながる行為を含みます）
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (13)本サービスの仕組みや本サービスで使用されているデザイン等の全部または一部を許可なく複製または模倣する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (14)本サービスにおいて、事実に反する、又はその恐れのある情報を提供する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (15)アクセス可能な本サービス又は他者の情報を改ざん、消去する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (16)有害なコンピュータプログラム等を送信し、又は他者が受信可能な状態におく行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (17)当社が提供するサービスに繋がっているサーバーやネットワークに対して悪影響を及ぼす行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (18)当社がサービスを提供する上で関係するあらゆるシステムに対して、不正にアクセスする行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (19)当社が提供するインターフェイスとは別の手法を用いてサービスにアクセスする行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (20)本サービスと同一又は類似の名称をその用途、手段にかかわらず、使用する一切の行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (21)日本通信販売協会が定める広告に関する自主基準に違反する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (22)選挙期間中であるか否かを問わず、選挙運動又はこれに類似する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(23)本サービスにおいて登録禁止商品を販売する行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (24)本サービスに関連して、特定商取引に関する法律上の訪問販売、電話勧誘販売、連鎖販売取引、特定継続的役務提供、業務提供誘引販売取引を行う行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(25)実態のない取引を行う行為</p>
        <p className={Style.termsOfUse__indentSentence}>(26)貸金取引を含む、資金移動を目的とする行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (27)商品券、プリペイドカード、印紙、証紙、切手、回数券その他有価証券の売買等（電子マネー又はプリペイドカードのチャージ等を含みます）を行う行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(28)許認可が必要な商品を、許認可を得ることなく販売する行為</p>
        <p className={Style.termsOfUse__indentSentence}>
          (29)特定商取引に関する法律、銃砲刀剣類所持等取締法、麻薬及び向精神薬取締法、絶滅のおそれのある野生動植物の種の国際取引に関する条約その他法令に違反する行為や犯罪的行為、若しくはその恐れのある行為、あるいはそれを幇助する行為
        </p>
        <p className={Style.termsOfUse__indentSentence}>(30)その他、当社が不適切と考える行為</p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第9条 商品の掲載について</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、店舗運営者情報等について正確な情報を当社の指定する方法で提供しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者は、ユーザーから取引を行うために問い合わせがあった場合は、取引に必要な情報を不足なく回答しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.商品掲載は法令に基づいて行わなければなりません。商品について販売することに許可や届出が必要なものは、店舗運営者の責任において許可を取得または届出を行うものとします。また、販売に年齢制限があるものについては、店舗運営者の責任において、年齢を確認した後に販売しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.店舗運営者は、別途当社の定める登録禁止商品を掲載してはなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.店舗運営者が物品以外のサービス提供を行う場合、ユーザーに対し売買契約の成立前にその提供時期を通知しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          6.当社は店舗運営者情報等について疑義がある場合、店舗運営者の出店又は商品の掲載を保留又は削除することができるものとし、店舗運営者はこのことを予め承諾するものとします。また、この場合において、店舗運営者は当社の調査に協力するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          7.店舗運営者は、売買契約の成立前に、ユーザーに対し売買契約の当事者は店舗運営者と顧客であり、当該契約に伴う権利・義務は店舗運営者と当該顧客との間で発生することを明確に表示するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第10条 売買契約と配送について</h4>
        <p className={Style.termsOfUse__sentence}>
          1.本サービスでユーザーが店舗運営者の商品を購入した場合、店舗運営者とユーザーとの間で売買契約が成立します。また、店舗運営者は、販売契約成立後に利用契約が終了した場合でも、当該販売契約を履行する義務を免れないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.
          店舗運営者は、本サービスを利用して販売した商品の代金の決済に関し、当社又は当社と提携する決済代行会社の提供する決済手段のいずれかによって行わなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者は自己の責任において、配送方法やギフト設定等その他の決定した売買契約に従い遅滞なく商品をユーザーに届けなければなりません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第11条 ポイントについて</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、ユーザーに対してポイントを付与し、ポイントを決済に利用させることができます。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.ポイントには利用期限を設定することができ、期限の設定は店舗運営者によって行うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.ポイントは現預金に交換することはできず、店舗運営者の運営する店舗での商品購入以外には利用することができません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第12条 利用料金の支払い</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、本サービスの利用の対価として、当社の規定する初期費用、月額費用、販売ごとにシステム利用料を当社の規定する方法にて支払うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者がユーザーにクレジットカード決済を利用させる場合、その利用に応じて株式会社ゼウスの定める決済手数料を負担するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者とユーザー間の売買契約が解除又は解約された場合、並びに理由の如何を問わず店舗運営者又はユーザーが実施したテスト決済である場合であっても、当社は、当該決済に要したシステム利用料について店舗運営者及びユーザーに返金いたしません。このことについて、店舗運営者は予めご了承するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第13条 返品及び返金対応について</h4>
        <p className={Style.termsOfUse__sentence}>
          1.顧客に対する商品の交換・返品・返金等の対応は、店舗運営者が行うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.売買契約が解除、取消し、無効等の理由により効力を失った場合その他の理由により顧客に対する返金対応が必要となった場合、店舗運営者は顧客に対し速やかに、顧客がその売買契約について支払った金額を返金しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.前項において、店舗運営者が顧客に返金すべき金額は、商品代金の他、顧客が負担した送料及び代引き手数料等も含めた金額とし、店舗運営者が負担したトランザクション費用及び決済手数料を顧客に対し返金すべき金額から控除してはならないものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第14条 設備について</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、本サービスを利用するために必要な設備（コンピュータ、通信機器、ソフトウェア、高速インターネットへの接続環境など）を、自己の費用と責任で準備するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者は自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者は、本サービスの利用中に、店舗運営者が保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、当社は店舗運営者に発生したかかる損害について一切責任を負わないものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第15条　解約（退会）</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者が本サービスの店舗運営者としての利用をやめる場合は、当社に連絡して当社が定める方法により解約手続を行う必要があります。解約は、利用を停止する月の1か月以上前にご連絡ください。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者の退会により当社と店舗運営者間の利用契約が解約されたとしても、その解約前に店舗運営者とユーザー間で売買契約が成立している場合、その売買契約は利用契約の解約を理由に解約とはなりませんのでご注意ください。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者が本サービスを退会した以降において、店舗運営者は本サービスの全てを利用することができなくなります。また、当社は店舗運営者の退会後、当該店舗運営者の店舗運営者発信情報を本サービスから削除するものとし、店舗運営者はこれをあらかじめ了承するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.当社は、本条に基づき当社が行った行為及び当社が店舗運営者に対し対応しなかったことにより店舗運営者又はユーザーに生じた損害について、一切責任を負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.第3項から第4項までの規定は、本サービスの利用契約について解除があった場合であっても同様とします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第16条　反社会的勢力の排除</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、次の各号の事項を現在及び将来にわたって確約するものとします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)自らが、暴力団、暴力団員、暴力団員でなくなったときから５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下総称して「反社会的勢力」という）ではないこと。
        </p>
        <p className={Style.termsOfUse__indentSentence}>(2)反社会的勢力と次の関係を有していないこと。</p>
        <p className={Style.termsOfUse__sentence}>
          　　ア　自らもしくは第三者の不正の利益を図る目的、又は第三者に損害を与える目的をもって反社会的勢力を利用していると認められる関係。
        </p>
        <p className={Style.termsOfUse__sentence}>
          　　イ　反社会的勢力に対して資金等を提供し、又は便宜を供与するなど反社会的勢力の維持、運営に協力し、又は関与している関係。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)自らの役員（取締役、執行役、執行役員、監査役、相談役、会長その他、名称の如何を問わず、経営に実質的に関与している者をいう）又は自らの特別利害関係者（役員の配偶者及び二親等内の血族、これらの者により議決権の過半数が所有されている会社、ならびに関係会社及びその役員をいう）が反社会的勢力ではないこと、及び反社会的勢力と社会的に非難されるべき関係を有していないこと。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (4)反社会的勢力に自己の名義を利用させ、本契約を締結するものでないこと。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)自ら又は第三者を利用して本契約に関して次の行為をしないこと。
        </p>
        <p className={Style.termsOfUse__sentence}>　　ア　暴力的な要求行為</p>
        <p className={Style.termsOfUse__sentence}>　　イ　法的な責任を超えた不当な要求行為</p>
        <p className={Style.termsOfUse__sentence}>　　ウ　取引に関して、脅迫的な言動をし、又は暴力を用いる行為</p>
        <p className={Style.termsOfUse__sentence}>
          　　エ　風説を流布し、偽計又は威力を用いて相手方の業務を妨害し、又は信用を毀損する行為
        </p>
        <p className={Style.termsOfUse__sentence}>　　オ　その他前各号に準ずる行為</p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第17条 違反行為等に対する措置</h4>
        <p className={Style.termsOfUse__sentence}>
          1.
          当社は、店舗運営者による本サービスの利用に関し店舗運営者その他の第三者から当社にクレーム・請求等がなされ、かつ当社が必要と認めた場合、店舗運営者に対しその調査の協力（裁判外紛争解決手続を含みます）を要求することができ、店舗運営者はこれに協力するものとします。また、店舗運営者が以下の各号のいずれかに該当すると判断した場合、店舗運営者への事前の通知又は催告を要することなく本サービス又は個別サービスの利用を停止すること（利用契約を解除すること）、又は必要な措置を講じることができるものとします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          1.店舗運営者が本規約に定められている事項に違反した場合、又はそのおそれがあると当社が判断した場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          2.店舗運営者による本サービス又は個別サービスの利用に関し、他者から当社にクレーム・請求等が行われ、かつ当社が必要と認めた場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          3.電話、電子メール等による連絡がとれない場合（定期的なメール配信において、当社のメールサーバへ、受信メールサーバエラーやあて先不明などのエラー通知が一定回数以上届いた場合を含む）
        </p>
        <p className={Style.termsOfUse__indentSentence}>4.店舗運営者宛に発送した郵便物が当社に返送された場合</p>
        <p className={Style.termsOfUse__indentSentence}>5.店舗運営者が法令等の違反により刑事処分等を受けた場合</p>
        <p className={Style.termsOfUse__indentSentence}>6.支払停止又は支払不能となった場合</p>
        <p className={Style.termsOfUse__indentSentence}>
          7.差押え、仮差押えもしくは競売の申立てがあったとき、又は公租公課の滞納処分を受けた場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          8.破産、民事再生開始、会社更生開始もしくは特別清算開始の申立てがあったとき、又は信用状態に重大な不安が生じた場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>9.監督官庁から営業許可の取消、停止等の処分を受けた場合</p>
        <p className={Style.termsOfUse__indentSentence}>
          10.店舗運営者が、ユーザーに対してサービスの提供を行うべき日時にサービスの提供を行わなかった場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          11.本規約に違反し、当社がかかる違反の是正を催告した後、合理的な期間内に是正されない場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          12.その他、当社が、自己の裁量により利用契約の解約を希望する場合
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者が本条第1項各号のいずれかに該当することにより当社が損害を被った場合、利用契約の解除の有無にかかわらず、当該店舗運営者は当社に対して、被った損害を賠償しなければなりません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.当社が利用契約を解除したことにより店舗運営者に損害が発生したとしても、当社は一切責任を負いません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.本条の規定により当社が店舗運営者との契約を解除した場合、店舗運営者は、当社に対して負っている債務の一切について当然に期限の利益を失います。店舗運営者は当社に債務の支払いを直ちに行わなければいけません。また、店舗運営者が債務の支払を遅滞した場合、店舗運営者は契約解除された日の翌日から起算して年14.6％の割合による遅延損害金を当社に支払うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.当社による店舗運営者に対する利用停止措置（利用契約の解約）に関する質問・苦情は一切受け付けません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          6.本条に基づく解除により、顧客に損害が生じた場合について、当社はその責任を負わず、当該店舗運営者がその責任の一切を追うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          7.登録抹消後の利用者情報の取扱については、第5条（店舗運営者情報等の取扱い）の規定に従うものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第18条 本規約の変更</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は以下の場合に、当社の裁量により、本規約を変更することができます。
        </p>
        <p className={Style.termsOfUse__indentSentence}>(1)本規約の変更が、店舗運営者の一般の利益に適合するとき。</p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)本規約の変更が、利用契約の契約目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は前項による本規約の変更にあたり、変更後の本規約の効力発生日の１か月前までに、本規約を変更する旨及び変更後の本規約の内容とその効力発生日を本社提供サービスのサイトに掲示し、または店舗運営者に電子メールで通知します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.変更後の本規約の効力発生日以降に店舗運営者が当社提供サービスを利用したときは、店舗運営者は、本規約の変更に同意したものとみなします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第19条 当社の知的財産権等</h4>
        <p className={Style.termsOfUse__sentence}>
          1.本サービス又に掲載される、もしくは本サービスにより配信される、情報・データ、データベース等の情報・データの集合体（以下「データ等」といいます）の著作権（本サービス及び本サービスに関連して使用されている全てのソフトウェアに関する著作権を含みます）、特許権、実用新案権、意匠権、商標権、著作権、ドメイン・ネーム及びその他の知的財産権ならびにこれらの出願又は登録に関する権利等の知的財産権その他一切の権利（以下「知的財産権等」といいます）は、当社又は本サービスに当該データ等を提供している提携先を含む正当な権利を有する者に帰属します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者は、当社、当社の提携先、他の店舗運営者及びユーザーが権利を有する知的財産について複製、公開、送信、頒布、譲渡、貸与、翻訳、翻案、使用許諾、転載又は再利用しないことに同意するものとします。ただし、当該知的財産の権利者から事前に文書による承諾を受けた場合を除きます。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者が前項に違反した場合には、店舗運営者の費用と責任において、かかる問題を解決するとともに、当社に何らの損害を与えないものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第20条 店舗運営者発信情報の取扱い</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、店舗運営者発信情報が店舗運営者その他の第三者の知的財産権等を侵害していないことを保証するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者は、店舗運営者発信情報にユーザーその他の第三者の個人情報を漏洩してはなりません。プライバシー情報についても同様に漏洩させてはいけません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.当社は、店舗運営者発信情報が第8条（店舗運営者の禁止事項）に抵触する、又は抵触するおそれがあると当社が判断場合その他当社が必要と認めた場合には、当該店舗運営者発信情報について、掲載の保留、修正、削除、掲載場所の変更その他必要な措置をとることができるものとし、店舗運営者はこのことをあらかじめ承諾するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第21条 ユーザー投稿データの取扱い</h4>
        <p className={Style.termsOfUse__sentence}>
          レビュー等のユーザー投稿データについては、記載した者に責任があるものとし、当社は、ユーザー投稿データの内容について一切の責任を負いません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第22条 秘密情報の取扱い</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、本サービス遂行のため当社より提供を受けた技術上又は営業上その他業務上の情報のうち、当社が特に秘密である旨あらかじめ書面で指定した情報で、提供の際に秘密情報の範囲を特定し、秘密情報である旨の表示を明記した情報（以下「秘密情報」といいます。）を第三者に開示又は漏洩しないものとします。ただし、当社からあらかじめ書面による承諾を受けた場合及び次の各号のいずれかに該当する情報についてはこの限りではありません。
        </p>
        <p className={Style.termsOfUse__indentSentence}>(1) 秘密保持義務を負うことなく既に保有している情報</p>
        <p className={Style.termsOfUse__indentSentence}>(2) 秘密保持義務を負うことなく第三者から正当に入手した情報</p>
        <p className={Style.termsOfUse__indentSentence}>(3) 当社から提供を受けた情報によらず、独自に開発した情報</p>
        <p className={Style.termsOfUse__indentSentence}>
          (4) 利用契約等に違反することなく、かつ、受領の前後を問わず公知となった情報
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (5) 本条に従った指定、範囲の特定や秘密情報である旨の表示がなされず提供された情報
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.前項の定めにかかわらず、店舗運営者は、秘密情報のうち法令の定めに基づき又は権限ある官公署からの要求により開示すべき情報を、当該法令の定めに基づく開示先又は当該官公署に対し開示することができるものとします。この場合、店舗運営者は、関連法令に反しない限り、当該開示前に開示する旨を当社に通知するものとし、開示前に通知を行うことができない場合は開示後すみやかにこれを行うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.店舗運営者が秘密情報の提供を受けた場合は、当該秘密情報の管理に必要な措置を講ずるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.店舗運営者が秘密情報の提供を受けた場合は、当社より提供を受けた秘密情報を本サービス遂行目的の範囲内でのみ使用し、本サービス遂行上必要な範囲内で秘密情報を化体した資料等（以下本条において「資料等」といいます。）を複製又は改変（以下本項においてあわせて「複製等」といいます。）することができるものとします。この場合、店舗運営者は、当該複製等された秘密情報についても、本条に定める秘密情報として取り扱うものとします。なお、本サービス遂行上必要な範囲を超える複製等が必要な場合は、あらかじめ当社から書面による承諾を受けるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.秘密情報の提供を受けた店舗運営者は、当社の要請があったときは資料等（本条第4項に基づき当社の承諾を得て複製、改変した秘密情報を含みます。）を当社に返還し、秘密情報が店舗運営者の設備又は本サービス用設備に蓄積されている場合はこれを完全に消去するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第23条 本サービスの停止、変更、終了</h4>
        <p className={Style.termsOfUse__sentence}>
          1．当社は、当社の都合により、本サービスの内容を変更し、又は本サービスの提供を終了することができるものとします。なお、当社が本サービスを停止、変更又は終了（以下「停止等」といいます。）する場合、店舗運営者に対して可能な限り事前に通知するよう努めますが、以下のような緊急の場合等、事前に通知ができないこともありますので予めご了承ください。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)
          本サービス、その他本サービスを提供するために必要なシステムのメンテナンス、電気通信設備の保守上又は工事上やむを得ないとき、またこれらにやむを得ない障害が発生したとき
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)
          本サービスに著しい負荷や障害が与えられることによって正常なサービスを提供することが困難である場合、又は困難であると当社が判断したとき
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)　データの改ざん、ハッキング等本サービスを提供することにより、当社、その他の店舗運営者及び第三者が著しい損害を受ける可能性を当社が認知したとき
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (4) 電気通信事業者又は国内外の電気通信事業体による電気通信サービス、電力会社による電力供給サービス、その他の公
          共サービスの提供が停止されることで、本サービスの提供が困難になったとき
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)
          地震・津波・台風・落雷その他の天災地変､戦争､内乱､法令の制定改廃その他不可抗力等により、非常事態が発生した場合､又はそのおそれがあるとき
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (6) その他、当社が本サービスの提供を停止、緊急停止する必要があると判断した場合
        </p>
        <p className={Style.termsOfUse__sentence}>
          2. 当社は店舗運営者及び第三者からの緊急停止要請に関して原則としてこれを受け付けません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.
          第1項に基づき本サービス又は個別サービスの内容が変更、停止又は終了された場合、当社は、これに起因して生じた店舗運営者及び第三者が被った損害について、一切責任を負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.
          当社が本サービスを停止すること、ならびに停止できなかったことによって店舗運営者及び第三者が損害を被った場合も、当社は一切の賠償責任を負いません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第24条 委託</h4>
        当社は、店舗運営者に対する本サービスに関して必要となる業務の全部又は一部を第三者（コンテンツ等を提供する情報の提供者を含みます）に委託することができるものとします。
        <br />
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第25条 免責規定</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は、本サービスが店舗運営者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、及び不具合が生じないことについて、何ら保証するものではありません。当該情報に起因して店舗運営者及び第三者に損害が発生したとしても、当社は一切責任を負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、本サービスの利用に起因し、又はこれに関連して発生した店舗運営者及び第三者の損害（店舗運営者及び他者の間で生じたトラブルに起因する損害も含みます）、及び本サービスを利用できなかったことにより発生した店舗運営者及び第三者の損害（本条において、以下に具体的に定める損害を含み、これらに限られません）に対し、当社に故意又は重大な過失がある場合を除き、いかなる責任も負わないものとし、損害賠償義務も一切負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.当社は、当社に故意又は重大な過失がある場合を除き、本規約の定めに従って当社が行った行為の結果について、店舗運営者及び第三者に対して、その原因のいかんを問わず、いかなる責任も負担しないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.当社は、本サービスを提供する機器の故障、トラブル、停電など、及び通信回線の異常など当社の予測を超えた不可抗力について、いかなる責任も負いません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          5.店舗運営者は、本サービスを利用するに当たり、自らの責任で、店舗運営者に関するデータ及び商品情報等、自らの商品の販売に必要な情報についてのバックアップをとらなければなりません。システムの障害などにより本サービス上のこれらの情報が消失又は紛失した場合であっても、当社は、自らに故意又は重大な過失がある場合を除いて一切責任を負いません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          6.店舗運営者は、自己の個人情報を利用して本サービス上でなされた一切の行為及びその結果について、当該行為を自己が行ったか否かを問わず、一切の責任を負うものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          7.当社は、店舗運営者の個人情報が他者に使用されたことによって店舗運営者又は第三者が被る損害について、当該店舗運営者の故意過失の有無にかかわらず一切責任を負わないものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          8.店舗運営者は、本サービスの利用及び本サービスを利用して行ったすべての行為ならびにその結果（店舗運営者発信情報の内容を含みます）について責任を負うものとし、本サービスの利用により当社もしくは第三者との間で紛争が生じた場合、又は当社もしくは第三者に対する損害を与えた場合、店舗運営者自身の責任と費用をもって解決するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          9.当社は、店舗運営者と顧客その他の第三者との間の商品の不着、到着遅延、契約不適合責任、著作権、商標権等の知的財産権若しくは人格権等に関する紛争について、店舗運営者の同意を得ることなく、当該顧客又は当該店舗運営者に関する紛争に関係する第三者（警察等の司法機関を含みますが、これに限られません。）に対し、店舗運営者に関する情報提供、当該紛争に関する情報提供その他の援助を行うことができるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          10.
          店舗運営者は、本サービスを利用することが、店舗運営者に適用のある法令（特定商取引に関する法律を含みますが、これに限られません。）、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査し、必要に応じてユーザーに対し必要な表示又は通知を行うものとします。当社は、店舗運営者による本サービスの利用が、店舗運営者に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          11.店舗運営者が、本サービスに関連してユーザーその他の第三者からクレームを受け又はそれらの者との間で紛争が生じた場合には、直ちにその内容を当社に通知するとともに、店舗運営者の費用と責任においてそのクレーム又は紛争を処理し、当社が本項に関して経過又は結果の報告を求めた場合は、直ちにその経過又は結果を当社に報告するものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          12.店舗運営者と顧客間の販売契約に関してチャージバックその他の決済事業者等が定める支払いの拒絶又は返還事由が発生した場合、当社は顧客に対し、決済手段の全部または一部を利用させないことができるものとします。当社は、本項に定める措置により店舗運営者に生じた損害に関し、当社に故意又は重大な過失がない限り、責任を負いません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          13.店舗運営者による本サービスの利用に伴い、当社の債務不履行又は不法行為に基づき店舗運営者に損害が発生した場合、当社は店舗運営者に対し、本サービスにおいて店舗運営者が支払った直近のサービス利用料の6カ月分を上限として、損害賠償責任を負います。ただし、当社に故意又は重過失がある場合はこの限りではありません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          14.本サービスのサイトからは他のウェブサイトなどへリンクをしている場合があります。移動した先のホームページは当社が管理運営するものでない場合、本サービス外のサイトやリソースの利用可能性については責任を有しておりません。また、当該サイトやリソースに包含され、又は当該サイトやリソース上で利用が可能となっている情報、広告、商品、役務などについては一切責任を負うものではありません。したがって、当社には、それらの情報、広告、商品、サービスなどに起因又は関連して生じた一切の損害（間接的であると直接的であるとを問いません）について賠償する責任はありません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          15.本条の規定にもかかわらず、強行法規、裁判所の確定判決等により本規約に規定する当社の免責が認められない場合には、当社は、店舗運営者の被った通常かつ直接の損害に限り賠償をする責任を負担します。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第26条 損害賠償</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者の行為（店舗運営者の行為が原因で生じたクレーム等を含みます。）に起因して当社に損害が発生した場合、当社は店舗運営者に対し、当該損害の全額（当社が負担する弁護士費用を含みます。）を賠償請求できるものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.店舗運営者による本サービスの利用に関連して、当社が、店舗運営者その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合、その店舗運営者は当該請求に基づき当社が当該第三者に支払をせざるを得なくなった金額を賠償しなければなりません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第27条 権利義務の譲渡等</h4>
        <p className={Style.termsOfUse__sentence}>
          1.店舗運営者は、当社の書面による事前の承諾を得ない状態で、利用契約上の地位又は本規約に基づく権利（本サービスのIDを含めます）若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに店舗運営者の登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、店舗運営者は、このような譲渡につき本項において予め同意したものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第28条 分離可能性</h4>
        <p className={Style.termsOfUse__sentence}>
          本規約のいずれかの規定が、法律に反しているとされた場合、当該規定は、その法律に反していると解釈された部分に限って、当社とその店舗運営者との契約には適用されないものとします。ただし、その場合でも、本規約の他の規定の効力には影響しないものとします。また、この場合において本規約のうち法律に反しているとされた条項又は部分については、本規約の趣旨並びに法律的及び経済的に同等の効果を確保できるように、当社と店舗運営者がお互いに協議をするものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第29条 存続規定</h4>
        <p className={Style.termsOfUse__sentence}>
          利用契約の終了後も、本規約中、その性質上存続すべき条項（当社の免責について定めた条項を含むがこれに限られません）は有効に存続するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第30条 準拠法と合意管轄</h4>
        <p className={Style.termsOfUse__sentence}>
          当社と店舗運営者との間で、本規約に基づく又はこれに関連する訴訟の必要が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。また、本規約に関する準拠法は、日本法とします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第31条 協議解決</h4>
        <p className={Style.termsOfUse__sentence}>
          当社及び店舗運営者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>以上</p>
        <p className={Style.termsOfUse__sentence}>制定日 2021年08月02日</p>
      </div>
      <br />
      <br />
      <h3 className={Style.termsOfUse__h3}>comachicartアプリストア及び当社アプリ利用の特約</h3>
        <div className={Style.termsOfUse__section}>
          <p className={Style.termsOfUse__sentence}>
            株式会社イーゼ(以下「当社」といいます。)は、当社が提供するcomachicartの付加サービスである「comachicartアプリストア」及びcomachicartアプリストア上で提供する「当社アプリ」に関して、以下のとおりcomachicartアプリストア及び当社アプリ利用の特約(以下、「本規約」といいます。)を定めます。
            本規約は、comachicartの利用契約者(店舗運営者)に適用されます。また、同契約者による「comachicartアプリストア」及び「当社アプリ」の利用は、本規約への同意を前提とし、その利用により、店舗運営者は本規約に同意したものとみなされます。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第1章 総則</h4>
          <h5 className={Style.termsOfUse__h5}>第1条（定義）</h5>
          <p className={Style.termsOfUse__sentence}>
            株式会社イーゼ（以下「当社」といいます。）は、個人情報保護を企業における重要な社会的使命・責務と認識し、本サービスを利用する全ての方（以下「ご利用者様」といいます）のプライバシーを尊重し、ご利用者様の個人情報を適切に管理運用するために遵守するべき基本事項として本ポリシーを定めます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (1)「comachicart」とは、当社が運営・提供するインターネット上で商品の販売を行うことができるプラットフォーム提供サービス「comachicart」(URL: <a href="https://www.comachicart.jp/">https://www.comachicart.jp/</a>)のことをいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (2)「本サービス」とは、店舗運営者がcomachicartの機能追加などを行うことができるウェブアプリケーションを提供するサービスである「comachicartアプリストア」のことをいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (3)「店舗運営者」とは、comachicartの利用契約を締結している法人及び個人事業主のことをいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (4)「当社アプリ」とは、comachicartアプリストア上で、当社が開発し店舗運営者に提供するウェブアプリケーションのことをいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (5)「本サービスサイト」とは、当社が提供するサービス「comachicart」についての情報を発信するWebサイト(URL: <a href="https://www.comachicart.jp/">https://www.comachicart.jp/</a>)のことをいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (6)「ユーザーデータ」とは、当社アプリのインストール及び利用に伴い設定・作成されたデータの一切をいいます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (7)「電子データ」とは、当社アプリを導入し、又は当社アプリを用いてリンクしている、comachicartを利用して開業・作成されたネットショップ及び契約者が独自に開設しているウェブサイトに関するデータの一切をいいます。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第2条（本規約の適用及び変更）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、本サービス及び当社アプリを利用するためには、本利用規約の全てに同意して頂く必要があり、本サービス及び当社アプリを利用した時は、本利用規約に同意したものとみなされるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は以下の場合に、当社の裁量により、本規約を変更することができます。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (1)本規約の変更が、店舗運営者の一般の利益に適合するとき。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (2)本規約の変更が、利用契約の変更目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.当社は前項による本規約の変更にあたり、変更後の本規約の効力発生日の７日前までに、本規約を変更する旨及び変更後の本規約の内容と効力発生日を本サービスサイトへの掲示など当社が適当と認める方法で通知します。店舗運営者は、この通知を覚知するため、常に本サービスサイトにおける掲示を確認するものとします。なお、変更後の効力発生日以降に店舗運営者が本サービスを利用したときは、店舗運営者は本規約の変更に同意したものとみなします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            4.当社は、本規約の内容が変更されたことによって店舗運営者又は第三者に生じる結果及び損害について、当社に故意又は重大な過失がある場合を除き、損害賠償責任その他一切の責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第2章 本サービスの内容等</h4>
          <h5 className={Style.termsOfUse__h5}>第3条（本サービスの内容）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.本サービスにおいて提供するアプリケーションソフトウェアは、当社が開発し店舗運営者に提供するウェブアプリケーション(以下、「当社アプリ」といいます。)です。その機能等の詳細は、別途本サービス及び個別の当社アプリに掲載いたします。当該掲載の内容は、本規約と一体をなすものとします。なお、当該掲載と本規約の条項に矛盾が生じた場合、本規約の条項を優先して適用するものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、店舗運営者に事前に通知することなく、本サービス及び当社アプリの内容の全部又は一部の変更(機能の変更を含みます。)を行うことができるものとします。但し、comachicartに関するWebAPIの仕様に変更が生じた場合は、変更を緊急で行う場合を除き本サービスサイトへの掲載など当社が適当と認める方法により通知するものとします。この場合、当社は、当社に故意又は重大な過失がある場合を除き、変更により店舗運営者に生じた損失、損害、結果について一切責任を負いません。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.本サービスにおける当社アプリの提供は、本サービスを利用して当社アプリの提供を適正に受けた店舗運営者に対し、comachicartを利用する目的においてのみ、comachicartの利用期間中において、当社アプリの利用を許諾するものです。店舗運営者はいかなる場合においても、当社アプリの利用及び権利についていかなる再許諾の権限も有しないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            4.店舗運営者が、各当社アプリを利用した場合においての利用に関する契約（以下、利用契約）は、本規約に基づき、店舗運営者と当社の間で成立するものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            5.当社は、当社アプリの利用(ダウンロード、インストール、アプリ等の機能、権利を含みます。)、又はこれに関連して発生した店舗運営者の損害(第三者との間で生じたトラブルに起因する損害を含みます。)及び当社アプリを利用できなかったことにより発生した店舗運営者及び第三者の損害に関して、当社に故意又は重大な過失がある場合を除き、一切責任を負いません。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第3章 店舗運営者の利用</h4>
          <h5 className={Style.termsOfUse__h5}>第4条（本サービス及び当社アプリの利用）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.本サービス及び当社アプリは、comachicartを利用してネットショップを作成している店舗運営者に限り利用できます。当社アプリの利用契約期間中、comachicart及び各個別の当社アプリの一方又は双方の利用契約が解除、解約もしくはその他の事由により終了し、若しくは利用の停止措置を受けた場合には、終了又は、停止措置と同時に、当社アプリの利用契約は当然に解除されるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.店舗運営者が本サービス及び当社アプリを利用するには、別途当社が定める「comachicartサービス利用規約」(URL: <a href="https://www.comachicart.jp/">https://www.comachicart.jp/</a> )(以下、「基本サービスの利用規約」といいます。)に同意の上、comachicartの利用者となる必要があり、本規約に定めのない事項は、全て基本サービスの利用規約の定めが適用されるものとし、本規約に基本サービスの利用規約と矛盾する事項があるときは、本規約が優先して適用されるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.本サービスにおいては、店舗運営者が自己の責任により、本サービス上の当社アプリの機能、内容等を確認の上で、当社アプリをインストールし、利用するものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            4.店舗運営者は、本サービスにおいて「アプリを追加する」ボタンをクリックする等の当社の定める方法により当社アプリのインストールを開始する旨の操作又は意思表示をした時に、本規約の諸規定に従った当社アプリの利用契約が店舗運営者と当社の間に成立し、店舗運営者は、本サービスを当社の定める方法で利用することができるようになります。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第5条（店舗運営者の義務）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、当社アプリをインストールすることで、comachicartアカウントに関連する店舗運営者情報の取得と管理を当社に許可するものとします。なお、当社が取得する個人情報については、当社のプライバシーポリシー(個人情報保護方針)が適用されます。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.店舗運営者は、当社アプリをインストールすることで、当社が店舗運営者情報の取得と管理を行う事に同意するものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.店舗運営者は、当社がアプリ等の登録の削除を行った場合は、契約期間中であっても当社のアプリ等の利用ができなくなることに予め同意するものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第6条（利用料金と解約）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社アプリの内、有料のアプリには、アプリの利用を認める対価としてライセンス料(以下、「利用料」といいます。)を設定しています。また、利用料は、月額費用(固定金額)により請求されます。詳細は、当社アプリのダウンロード時に、アプリ毎にご確認ください。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.利用料が月額にて発生する当社アプリの利用契約の期間は、1カ月間とします。ただし、当社アプリごとに個別に契約が成立した日の属する月において、契約日が月の途中の場合は、当該契約成立日の属する当月の末日までを契約期間とします。当社アプリの利用者が、当社の定める方式により解約をしない限り、当社アプリの利用契約の期間はその後もさらに1カ月毎に更新されるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.当社は、いつでも利用料を変更できます。なお、月額にて発生する利用料が変更された場合は、変更された日の属する月の翌月に発生する利用料から変更後の利用料が適用されるものとします。利用料に変更がある場合は、その１ヵ月前までにその旨を本サービスサイトへの掲示など当社が妥当と判断する方法により、店舗運営者に通知します。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第7条（支払い）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、当社アプリの利用料金が月額にて発生する場合、当社の規定する方法にて支払うものとします。なお、当社アプリの利用契約の期間中に解約した場合であっても、利用料金の日割精算等による返金は行わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.金融機関に支払う振込み手数料その他の支払費用は、店舗運営者の負担とします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.店舗運営者が当社の指定する支払い方法以外で入金した等、店舗運営者の過失を要因として当社が店舗運営者の入金した事実を確認できない場合、店舗運営者または他の第三者が被った損害について当社は一切の責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第8条（店舗運営者による解約）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、別途当社が定める手続きに従い、当社アプリの利用契約の解約を申し入れることができます。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.前項に基づき解約の申し入れがなされた後、当社が指定する解約日以降、当社はユーザーデータをすみやかに削除するものとし、解約後のユーザーデータの保存又は復元は全て店舗運営者の責任において行うものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第4章 利用上の責務</h4>
          <h5 className={Style.termsOfUse__h5}>第9条（利用環境の整備）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、本サービス及び当社アプリを利用するために必要な通信機器、ソフトウェア、通信回線等のすべてを自己の責任と費用をもって準備し、本サービス及び当社アプリを利用するために必要となる全ての環境の整備及び維持管理を行うものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、店舗運営者の使用する本サービス及び当社アプリの利用に供する装置、ソフトウェア又は通信網の瑕疵、障害、動作不良、若しくは不具合により、ユーザーに損害が生じたときであってもその一切の責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第10条（自己責任の原則）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、ユーザーデータの中に自己又は第三者の個人情報等が含まれる場合には、自らの責任においてこれを管理・使用するものとします。本サービス及び当社アプリを利用して、ユーザーの間でなされる情報の授受、及びそれに付随して行われる行為及び損害について当社は一切責任を負わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.店舗運営者は、自己の責任において、ユーザーデータのバックアップ等保存を行うものとし、当社は、本サービス及び当社アプリの提供の中止、中断、又は解約後のユーザーデータの毀滅に関して一切その責任を負わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.店舗運営者は、本サービス及び当社アプリの利用につき一切の責任を負うものとし、当社に対していかなる迷惑及び損害等を与えないものとします。また、契約者による本サービス及び当社アプリの利用により、当社が損害等を被った場合には、当社が当該店舗運営者との利用契約を解除したか否かに関わらず、当該店舗運営者は当社に対して当該損害等を賠償する責任を負うものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            4.店舗運営者が、本サービス及び当社アプリの利用に関して、他の店舗運営者または第三者に対して損害を与えた場合、当該店舗運営者は自己の費用負担と責任において当該損害を賠償するものとし、当社は一切の責任を負わないものとします。なお、当社が、店舗運営者と他の店舗運営者又は第三者との紛争、その他店舗運営者の責めに帰すべき事由に起因して費用（弁護士報酬、証人費用、証拠収集費用及びその他の訴訟遂行上の合理的費用を含む）を負担することとなる場合、当社は、その費用を、現実に負担が生じる前であっても、損害等の一部として店舗運営者に請求することができるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            5.当社は、店舗運営者の電子データについて、本サービス及び当社アプリによる消失等の不具合等の一切が生じないことを保証するものではありません。店舗運営者は、自己の費用と責任において、適宜、電子データのバックアップを実施するものとします。また、当社は、当社アプリが導入又はリンクされるネットショップ、ウェブサイト等に生じた不具合について、当社アプリによる影響の有無に係わらず、当社に故意又は重大な過失がある場合を除き、一切の責任を負わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            6.店舗運営者は、店舗運営者の電子データを原因として、店舗運営者又は第三者に損害等が生じた場合は、自己の費用負担と責任において当該損害を賠償するものとし、当社は一切の責任を負わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            7.当社は、理由の如何を問わず、当社アプリの利用に関連して電子データが滅失又は毀損（改ざんを含む。以下同じ。）した場合に、これを復元する義務を負わないものとし、当該滅失又は毀損により店舗運営者又は第三者に生じた損害等について、当社に故意又は重大な過失がある場合を除き、一切の責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第11条（利用停止措置等）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者が、以下の各号のいずれかに該当し、又は該当するおそれがあるときは、当社は、事前に通知、催告することなく、直ちに、当該店舗運営者に対するcomachicart、本サービス及び当社アプリの全部又は一部の利用を停止し、当社アプリの利用契約の取り消し若しくは解除等の措置のいずれか又は全てを行うことができるものとします。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (1)本規約及びcomachicartサービス利用規約のいずれかの条項に違反し、又は当社の本規約及びcomachicartサービス利用規約に基づく指示に従わないとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (2)店舗運営者が以下に該当する行為を行ったとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            　①当社又は当社の従業員等に対する暴力的な要求行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            　②当社又は当社の従業員等に対する法的な責任を超えた不当な要求行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            　③取引に関して、当社又は当社の従業員等に対する脅迫的な言動を行い、又は暴力を用いる行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            　④風説の流布、偽計若しくは威力を用いて当社の信用を毀損し、又は当社の業務を妨害する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            　⑤前各項目に準じる行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (3)登録情報に虚偽の事実があることが判明した場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (4)暴力団、反政府組織、その他反社会的組織であるか、若しくはそれらの構成員・関係者となったとき、又はこれらの者と何らかの関係があることが明らかとなったとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (5)当社からの連絡に対して、当社の指定する期間内に返信・応答が無い場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (6)店舗運営者が、ライセンス料等を支払わないとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (7)差押、仮差押、仮処分、強制執行若しくは競売の申立てがあったとき、租税公課を滞納し督促を受けたとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (8)支払停止若しくは支払不能の状態に陥ったとき、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算手続開始その他これに準じる手続きの申立てがなされ、若しくは自らかかる申立てを行ったとき
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (9)店舗運営者が、当社の運営するいずれかのサービスの利用規約に違反し、過去に当該サービスの利用の停止、契約の解除等の処分を受けたことがある場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (10)その他本サービス及び当社アプリを提供することが不適当であると当社が判断したとき
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、本条に基づき、本サービス及び当社アプリの提供を停止、利用契約の解除その他第1項に定める措置を実施したことにより店舗運営者又は第三者に生じる損害・結果について、何ら責任を負わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.本条による本サービス及び当社アプリの提供の停止、解除は、当社の店舗運営者に対する損害賠償請求を何ら妨げないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第5章 保障</h4>
          <h5 className={Style.termsOfUse__h5}>第12条（保証）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社は、本サービス及び当社アプリの機能が店舗運営者の要件を満たしていること、本サービス及び当社アプリの操作が中断されないこと、若しくはエラーがないこと、又はそれらが欠陥でないことを保証するものでないことを店舗運営者は予め理解し、承諾するものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、本サービス及び当社アプリが、紛失、攻撃、ウィルス、干渉、ハッキングその他のセキュリティ侵害がないことを表明又は保証しません。また、当社は何ら責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第13条（保証の否認及び免責）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社は、当社アプリの内容、作動及び提供並びに店舗運営者が当社アプリを通じて得る情報等について、その完全性、正確性、確実性、有用性等いかなる保証も行わないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.店舗運営者は、当社アプリの利用にあたり、インターネット回線の混雑、システムに対する負荷などの状況により、当社アプリにアクセスしにくい状況の発生等が生じる可能性のあることを予め了承するものとし、当社はこれにより店舗運営者又は第三者に生じたいかなる損害等についても補償しないものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.店舗運営者は、当社アプリの利用にあたり、契約者に適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、店舗運営者による当社アプリの利用が、契約者に適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。
          </p>
          <p className={Style.termsOfUse__sentence}>
            4.当社アプリの利用により店舗運営者と他の店舗運営者又は第三者との間において生じた取引、連絡、紛争等については、店舗運営者の責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第6章 本サービス及び当社アプリの停止、終了</h4>
          <h5 className={Style.termsOfUse__h5}>第14条（本サービス及び当社アプリの停止、終了）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社は、当社の都合により、本サービス及び当社アプリの内容の停止、又は本サービス及び当社アプリの提供を終了することができるものとします。なお、当社が本サービス及び当社アプリの内容の全部又は一部の停止を行う場合、店舗運営者に対して当社が妥当と判断する方法により、可能な限り事前に通知するように努めますが、以下のような緊急の場合など、事前に通知ができないこともありますので予めご了承ください。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (1)サーバ、通信回線若しくはその他の設備の故障、障害の発生又はその他の事由により本サービス及び当社アプリの提供ができなくなった場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (2)システム(サーバ、通信回線や電源、それらを収容する建築物などを含む)の保守、点検、修理、変更を定期的に又は緊急に行う場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (3)火災、停電などにより本サービス及び当社アプリの提供ができなくなった場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (4)地震、噴火、洪水、台風、津波などの天災により本サービス及び当社アプリの提供ができなくなった場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (5)戦争、変乱、暴動、騒乱、労働争議、疫病の蔓延等その他不可抗力により本サービス及び当社アプリの提供ができなくなった場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (6)法令による規制、司法命令等の適用により本サービス及び当社アプリの提供ができなくなった場合
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (7)その他、運用上、技術上当社が本サービス及び当社アプリの一時的な中断を必要と判断した場合
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、任意の理由により、本サービス及び当社アプリの全部又は一部を終了することができるものとします。本サービス及び当社アプリの全部又は一部の終了を行う場合、その１ヵ月前までにその旨を本サービスサイトへの掲示など当社が妥当と判断する方法により、店舗運営者に通知します。当社アプリについても同様とします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.当社は、本サービス及び当社アプリの一時停止、及び終了により店舗運営者に生じた損害について、一切その責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第15条（アクセス制限）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社は、店舗運営者に事前に通知することなく、当社アプリ、本サービス、APIへのアクセスを制限することができるものとし、それによりアプリ等の変更が必要になる場合があります。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社は、前項の措置を実施したことにより店舗運営者又は第三者に生じる損害・結果について、当社に故意又は重大な過失がある場合を除き、何ら責任を負わないものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第7章 損害賠償等</h4>
          <h5 className={Style.termsOfUse__h5}>第16条（損害賠償）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.当社は、本サービス及び当社アプリの利用に関して、当社の責めに帰すべき事由によって店舗運営者に損害が発生した場合には、当社の故意又は重過失による場合を除き、店舗運営者に現実に発生した直接かつ通常の損害を賠償するものとします。なお、当社は店舗運営者に対し、当該損害に関して本サービス及び当社アプリの利用料の返金をした場合には、返金額に相当する範囲において損害を賠償する義務を免れるものとします。なお、本条に伴う本サービス及び当社アプリの利用料の返金額の上限は、直近の本サービス及び当社アプリの利用料の６ヵ月分を上限とする。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.店舗運営者が、本規約に定める事項に違反したことにより、当社が損害を被った場合には、当社が当該店舗運営者との利用契約を解除したか否かに関わらず、当該店舗運営者は当社に対して当該損害を賠償する責任を負うものとします。なお、当社が、店舗運営者と第三者との紛争、その他店舗運営者の責に帰すべき事由に起因して費用(弁護士費用、証人費用、証拠収集費用及びその他の訴訟遂行上の合理的費用を含む)を負担することとなる場合、当社は、その費用を、現実に負担が生じる前であっても、損害の一部として店舗運営者に請求することができるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            3.前項の規定は、法人又はその他の団体が当該法人又はその他の団体に所属する個人を店舗運営者として登録した場合において、当該個人が本規約に定める事項に違反したことにより当社が損害を被った場合には、その時点で当該個人が法人又はその他の団体に所属しているか否かに関わらず、当該法人又は当該団体が当該損害を賠償する責任を負うものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h4 className={Style.termsOfUse__h4}>第8章 雑則</h4>
          <h5 className={Style.termsOfUse__h5}>第17条（利用権譲渡等の禁止）</h5>
          <p className={Style.termsOfUse__sentence}>
            店舗運営者は、当社の承諾なしに、本サービス及び当社アプリの店舗運営者としての地位並びに権利及び義務を第三者に譲渡又は貸与等の処分をできないものとします。本サービス及び当社アプリの利用に関する地位並びに権利及び義務についても同様とします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第18条（禁止事項）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.店舗運営者は、本サービス及び当社アプリの利用にあたり、以下の各号に定める行為を行ってはならないものとします。なお、当社は、自らの判断で、各号の該当性を判断し認定することができるものとし、店舗運営者はこれに従うものとします。
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (1)第三者、または当社が保有する知的財産権（著作権、意匠権、特許権、実用新案権、商標権、工業所有権等）及びその他の権利を侵害する行為、またはそのおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (2)第三者、または当社の財産権またはプライバシー権等の権利を侵害する行為、または侵害するおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (3)第三者もしくは当社を不当に差別もしくは誹謗中傷・侮辱し、他の契約者、第三者もしくは当社への差別を助長し、またはその名誉もしくは信用を毀損する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (4)第三者、または当社に不利益または損害を与える行為、またはそのおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (5)第三者の個人情報の売買または譲受に当たる行為、またはそのおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (6)詐欺、児童売買春、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく、または結びつくおそれの高い行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (7)わいせつ、児童ポルノもしくは児童虐待に相当する画像、映像、音声もしくは文書等を送信する行為、またはこれらを収録した媒体を販売する行為、またはその送信、販売を想起させる広告を送信する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (8)薬物犯罪、規制薬物等の濫用に結びつく、もしくは結びつくおそれの高い行為、または未承認医薬品等の広告を送信する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (9)貸金業を営む登録を受けないで、金銭の貸付の広告を送信する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (10)無限連鎖講（ネズミ講）を開設し、またはこれを勧誘する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (11)公序良俗に反する行為、またはそのおそれのある行為、またはそれを助長する行為、または助長するおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (12)公序良俗に反する情報を他の契約者または第三者に提供する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (13)法令に違反する行為や犯罪行為、そのおそれのある行為、または、それを教唆、幇助等する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (14)事実に反する、またはそのおそれのある情報を提供する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (15)他人になりすまして当社アプリを利用する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (16)IPアドレス、アカウント、パスワード、およびドメイン名を不正に使用する行為、または、不正目的をもって使用する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (17)コンピューターウィルス等有害なプログラムを当社アプリを通じて、または、当社アプリに関連して送信、使用又は提供する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (18)その行為が契約者の故意であるかどうかにかかわらず、当社アプリを介して、無差別または大量に不特定多数の者に対してその意思に反し、電子メールを送信する行為、または事前の承認があるかないかにかかわらず一定期間に大量の電子メールを配信する行為、通常の使用限度を超えた数の電子メールを送信する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (19)当社アプリおよび当社が提供する他のサービスの運営を妨げる行為、または、そのおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (20)当社、当社アプリおよびその他当社が提供するサービスの信用・名誉等を傷つける行為、または、そのおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (21)公職選挙法に違反する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (22)当社アプリを利用して、当社アプリと同様のサービス、関連サービス、または当社が提供するサービスと同様のサービスを提供し、または再販売する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (23)当社アプリを利用して、無断で他の契約者、第三者に広告、宣伝もしくは勧誘の電子メールを送信する行為、または人の殺害現場の画像等の残虐な情報、動物を殺傷・虐待する画像等の情報、その他社会通念上他者に著しく嫌悪感を抱かせる情報を送信する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (24)他の契約者、第三者の設備等またはインターネット接続サービス用設備の利用もしくは運営に支障を与える行為、または与えるおそれのある行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (25)違法な賭博・ギャンブルを行わせ、または違法な賭博・ギャンブルへの参加を勧誘する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (26)違法行為（けん銃等の譲渡、爆発物の不正な製造、児童ポルノの提供、公文書偽造、殺人、脅迫等）を請負し、仲介しまたは誘引（他人に依頼することを含む）する行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (27)人を自殺に誘引または勧誘する行為、または第三者に危害の及ぶおそれの高い自殺の手段等を紹介するなどの行為
          </p>
          <p className={Style.termsOfUse__indentSentence}>
            (28)その他、当社が不適切と判断する行為、又は別途当社が定める本サービス及び当社アプリ禁止事項に該当する行為
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第19条（準拠法）</h5>
          <p className={Style.termsOfUse__sentence}>
            本規約の成立、効力、履行および解釈に関しては、日本国法が適用されるものとします。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <h5 className={Style.termsOfUse__h5}>第20条（解釈及び管轄裁判所）</h5>
          <p className={Style.termsOfUse__sentence}>
            1.本規約の解釈を巡って疑義が生じた場合、当社は合理的な範囲でその解釈を決定できるものとします。
          </p>
          <p className={Style.termsOfUse__sentence}>
            2.当社と店舗運営者との間におけるすべての紛争については、訴額に応じて東京簡易裁判所又は東京地方裁判所を第一審の専属的管轄裁判所とすることを予め合意します。
          </p>
        </div>
        <div className={Style.termsOfUse__section}>
          <p className={Style.termsOfUse__sentence}>
          （附則）
          </p>
          <p className={Style.termsOfUse__sentence}>
          本規約は2024年9月26日から施行します。
          </p>
        </div>
      <br />
      <br />
      <h3 className={Style.termsOfUse__h3}>プライバシーポリシー</h3>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第1条 総則</h4>
        <p className={Style.termsOfUse__sentence}>
          株式会社イーゼ（以下「当社」といいます。）は、個人情報保護を企業における重要な社会的使命・責務と認識し、本サービスを利用する全ての方（以下「ご利用者様」といいます）のプライバシーを尊重し、ご利用者様の個人情報を適切に管理運用するために遵守するべき基本事項として本ポリシーを定めます。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第2条　個人情報の定義</h4>
        <p className={Style.termsOfUse__sentence}>
          個人情報とは、ご利用者様個人に関する情報であって、当該情報を構成する氏名、住所、電話番号、メールアドレスその他の記述等により当該ご利用者様を識別できるものをいいます。また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的にご利用者様個人を識別できるものも個人情報に含まれます。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第3条　個人情報の取得</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は、適法かつ公正な手段によって、当社のサービスで取り扱う個人情報（以下個人情報といいます）を取得します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.要配慮個人情報（個人情報保護法第2条に定めるものをいいます）については、当社の業務の遂行上必要な範囲外のものを取得しません。また、取得する場合にはご本人の同意をいただいたうえで取得します。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.当社が取得した個人情報が不足している場合には、当社のサービスの全部または一部を提供できない場合があります。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第4条　個人情報の利用目的</h4>
        <p className={Style.termsOfUse__sentence}>
          当社は、ご利用者様からご提供いただいた情報(以下「個人情報等」といいます。)を、以下に掲げる目的で使用いたします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)当社の商品及びサービス（以下総称して「当社サービス」といいます。）の提供のため
        </p>
        <p className={Style.termsOfUse__indentSentence}>(2)当社サービスに関するご案内、お問い合わせ等への対応のため</p>
        <p className={Style.termsOfUse__indentSentence}>(3)当社サービスに関する登録の受付及び本人確認のため</p>
        <p className={Style.termsOfUse__indentSentence}>
          (4)当社サービスに関する当社及び当社の関連会社の規約、ポリシー等に違反する行為に対し対応するため
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (5)当社及び当社サービスに関するお知らせや関連サービスのご案内のため
        </p>
        <p className={Style.termsOfUse__indentSentence}>(6)当社のマーケティング調査のため</p>
        <p className={Style.termsOfUse__indentSentence}>(7)その他、上記利用目的に付随する目的のため</p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第5条　個人情報の第三者提供について</h4>
        <p className={Style.termsOfUse__sentence}>
          当社で保管した個人情報等については、以下のいずれかに該当する場合を除き、第三者へ提供、取扱いの委託をすることはありません。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)当社が前条第1項ないし第7項に定める利用目的の達成に必要な範囲内において個人情報等の取扱いを委託する場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)事業の法人化に伴って個人情報等が引き継がれる形で提供される場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご利用者様の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>(4)その他、個人情報保護法その他の法令で認められる場合</p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第6条　外部委託について</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は、決済などの業務を外部に委託する際に、個人情報を必要最小限の範囲で委託する場合があります。その場合には、委託先が個人情報保護体制等において当社と同等以上の水準を確保していることを条件とし、当社は委託先に対し秘密を保持させるために、適正な監督を行います。
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、GDPRに準拠したサービスを保証しているAmazon Web Services,
          Inc.（以下「AWS」といいます）をデータ処理者として個人情報を保存しており、ご利用者様はこのAWSの環境内に個人情報データが保存されることについて、予め承諾するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第7条　個人情報の管理</h4>
        <p className={Style.termsOfUse__sentence}>1.当社は、個人情報の正確性を保ち、これを安全に管理します。</p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、個人情報の紛失、破壊、改ざん及び漏えいなどを防止するため、不正アクセス、コンピュータウィルス等に対する適正な情報セキュリティ対策を講じます。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.当社は、個人情報を持ち出し、本ポリシー及び利用規約に定めのない目的で外部へ送信する等により漏えいさせません。
        </p>
        <p className={Style.termsOfUse__sentence}>
          4.
          当社は、その従業者に個人データを取り扱わせるに当たっては、個人情報の安全管理が図られるよう、当該従業者に対する必要かつ適切な監督を行います。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第8条　個人情報の開示</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は、ご利用者様から、個人情報保護法の定めに基づき個人情報等の開示を求められたときは、ご利用者様ご本人からのご請求であることを確認の上で、ご利用者様に対し、遅滞なく開示を行います(当該個人情報等が存在しないときにはその旨を通知いたします。)。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社の個人情報の取扱いについてのご意見、ご質問等のお問い合せは、末尾に記載している連絡先までご連絡ください。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第9条　個人情報の訂正及び停止等</h4>
        <p className={Style.termsOfUse__sentence}>
          1.当社は、ご利用者様から以下の各号に記載するいずれかの求めがあったときは、ご利用者様ご本人からのご請求であることを確認の上で、遅滞なく必要な調査を行い、その結果に基づき、個人情報等の内容の訂正または利用停止を行い、その旨をご利用者様に通知します。なお、合理的な理由に基づいて訂正または利用停止を行わない旨の決定をしたときは、ご利用者様に対しその旨を通知いたします。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)個人情報等が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合
        </p>
        <p className={Style.termsOfUse__sentence}>
          2.当社は、ご利用者様から、ご利用者様の個人情報等について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、ご利用者様ご本人からのご請求であることを確認の上で、個人情報等の消去を行います。なお、合理的な理由に基づいて消去を行わない旨の決定をしたときは、ご利用者様に対しその旨を通知いたします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          3.個人情報保護法その他の法令により、当社が訂正等または利用停止等の義務を負わない場合は、前2項の規定は適用されません。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第10条　免責</h4>
        <p className={Style.termsOfUse__sentence}>
          以下の場合において、当社は個人情報の取扱いに関しての責任を一切負いません。
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (1)ご利用者様本人が、自らの意思もしくは自らの過失により、当サイトの使用又はその他別の手段を用いて第三者に個人情報を明らかにした場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (2)当社のサービスからリンクされる当社が管理していない外部のウェブサイト等において、ご利用者様が個人情報を提供した場合、又は意図せず個人情報を抜き取られてしまった場合
        </p>
        <p className={Style.termsOfUse__indentSentence}>
          (3)通常講ずるべき対策を講じた上では防止できないマルウェア、天変地異、その他当社の責によらない事由により個人情報が漏洩、損傷又は滅失した場合
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第11条　Cookieについて</h4>
        <p className={Style.termsOfUse__sentence}>
          当社のサイトでは、Cookieを利用しています。Cookieとは、webコンテンツへのアクセスに関する情報です。当社のサイトは、Cookieを個人情報にひも付ける場合があります。ブラウザの設定により、Cookieの設定を変更し、これらの機能を無効にすることができますが、その結果、本サービスの全部または一部の機能がご利用いただけなくなることがあります。以上についてご了承の上、必要に応じてCookie機能の使用及び停止をしてください。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第12条　統計処理データの利用</h4>
        <p className={Style.termsOfUse__sentence}>
          当社は、提供を受けた個人情報をもとに、個人を特定できないよう加工した統計データを作成することがあります。個人を特定できない統計データについては、当社は何ら制限なく利用することができるものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>第13条　本ポリシーの変更について</h4>
        <p className={Style.termsOfUse__sentence}>
          当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、個人情報等の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本ポリシーを変更することがあります。変更した場合には、本サイトに掲載する方法で事前にご利用者様に通知いたします。但し、法令上ご利用者様の同意が必要となるような内容の変更の場合は、当社所定の方法でご利用者様の同意を得るものとします。
        </p>
        <p className={Style.termsOfUse__sentence}>
          本規約の変更時には、ウェブサイト上に変更の旨を表示し、変更点が有効となる日付を明示するものとします。
        </p>
      </div>
      <div className={Style.termsOfUse__section}>
        <h4 className={Style.termsOfUse__h4}>お問い合わせ先</h4>
        <p className={Style.termsOfUse__sentence}>
          ご意見、ご質問等のお申出、その他個人情報等の取扱いに関するお問い合わせは、以下までご連絡をお願い致します。
        </p>
        <br />
        <p className={Style.termsOfUse__sentence}>株式会社イーゼ 個人情報保護管理責任者</p>
        <br />
        <p className={Style.termsOfUse__sentence}>連絡先：以下のコンタクトフォームよりご連絡ください。</p>
        <p className={Style.termsOfUse__sentence}>
          <a href="https://e-ize.jp/contact/" target="_blank" rel="noopener noreferrer">https://e-ize.jp/contact</a>
        </p>
        <br />
        <p className={Style.termsOfUse__sentence}>2021年08月02日 制定</p>
      </div>
    </div>
  );
};

export default ComachiTermOfUse;
